export default "__VITE_ASSET__1A_4BXQL__"